import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useRef, useState, useEffect } from "react";

import "swiper/css";
import "swiper/css/navigation";

import userImg from "../../Assests/images/david_pr.png";

const testimonials = [
  {
    name: "David L.",
    role: "CFO, Regional Restaurant Chain",
    text: "The team was professional, thorough, and communicated every step of the way. We received $67,000 in credits we didn't know existed.",
  },
  {
    name: "Sarah M.",
    role: "Owner, Neighborhood Bar",
    text: "As a small bar owner, I was skeptical, but Tip Credit Partners delivered exactly what they promised. $18,500 back in my pocket with zero hassle.",
  },
  {
    name: "Michael R.",
    role: "Owner, Fine Dining Restaurant Group",
    text: "We recovered over $45,000 in tax credits we didn't even know we were eligible for. The process was incredibly simple on our end.",
  },
];

const TestimonialSwiper = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  // 🔥 FORCE navigation init AFTER render
  useEffect(() => {
    if (
      swiperRef.current &&
      prevRef.current &&
      nextRef.current
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <>
      <Swiper
        direction="vertical"
        modules={[Navigation]}
        slidesPerView={1}
        className="testimonial-swiper"
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial-card d-flex align-items-center">
              <div className="rounded-circle-img">
                <img src={userImg} alt="client" className="user-img" />
              </div>

              <div className="content ms-4">
                <p className="text mb-3">{item.text}</p>
                <div className="stars mb-2">★★★★★</div>
                <h6 className="name mb-0">{item.name}</h6>
                <small className="role">{item.role}</small>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* CONTROLS */}
      <div className="swiper-controls">
        <button ref={prevRef} className="swiper-btn-prev">↑</button>

        <div className="swiper-pagination-custom">
          {String(activeIndex + 1).padStart(2, "0")} /{" "}
          {String(testimonials.length).padStart(2, "0")}
        </div>

        <button ref={nextRef} className="swiper-btn-next">↓</button>
      </div>
    </>
  );
};

export default TestimonialSwiper;
